import lowQuality from 'images/low-quality.svg';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

export const LowQuality = () => {
  const { t } = useTranslation();

  return <Image src={lowQuality} alt={t('lowQuality')} />;
};
